import { z } from 'zod';

/** Login form schema — the single source of truth for validation + payload type. */
export const loginSchema = z.object({
  email: z.string().min(1, 'Email is required').email('Enter a valid email address'),
  password: z.string().min(1, 'Password is required'),
  remember: z.boolean().optional().default(false),
});
export type LoginFormValues = z.infer<typeof loginSchema>;

/** MFA form schema: a 6-digit authenticator code, or a recovery code (xxxxx-xxxxx). */
export const mfaSchema = z.object({
  code: z
    .string()
    .transform((v) => v.replace(/\s+/g, ''))
    .pipe(z.string().regex(/^[0-9]{6}$/, 'Enter the 6-digit code from your authenticator app')),
});
export const recoveryCodeSchema = z.object({
  code: z
    .string()
    .transform((v) => v.trim().toLowerCase())
    .pipe(z.string().regex(/^[a-z0-9]{5}-?[a-z0-9]{5}$/, 'Enter one of your recovery codes, like abcde-fghjk')),
});
export type MfaFormValues = z.infer<typeof mfaSchema>;
